import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import Spinner from "../Components/Spinner";
import ErrorMessage from "../Components/ErrorMessage";
import { MdCheck } from "react-icons/md";
import { useLanguage } from "../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const VerifyEmail = () => {
    const {t} = useLanguage()
    const [searchParams] = useSearchParams();
    const email = searchParams.get("email");

    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [err, setErr] = useState({ message: "", display: false });

    const handleResend = async () => {
        if (!email) return;

        try {
            setLoading(true);
            setErr({ message: "", display: false });
            setSuccess(false);

            const response = await fetch(
                `${GEN_BACKEND_LINK}/resend_verify_email`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ email }),
                }
            );

            if (!response.ok) {
                throw new Error("Failed to resend email");
            }

            setSuccess(true);

            setTimeout(() => {
                setSuccess(false);
            }, 3000);

        } catch (error) {
            setErr({
                message: "Something went wrong. Please try again.",
                display: true,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="verify_email_cont">

            {success ? (
                <div className="verify_email_success">
                    <p className="verify_email_title fade-in"><MdCheck/></p>
                    <p className="verify_email_title fade-in">{t.verification.email_sent}</p>
                    <p className="verify_email_subtitle fade-in">
                        {t.verification.email_sent_sub}
                    </p>
                </div>
            ) : (
                <>
                    <p className="verify_email_title fade-in">{t.verification.verify_email_title}</p>

                    <p className="verify_email_subtitle fade-in">{t.verification.verify_email_subtitle}<strong>{email}</strong>.</p>

                    <p className="verify_email_message fade-in">
                        {t.verification.verify_email_message}
                    </p>

                    <button
                        className="resend_email_btn fade-in"
                        onClick={handleResend}
                        disabled={loading}
                    >
                        {loading ? (
                            <Spinner loading={true} />
                        ) : (
                            t.verification.resend_btn
                        )}
                    </button>

                    <ErrorMessage err={err} />

                    <p className="fade-in" id="privacy_policy_desc" dangerouslySetInnerHTML={{__html: t.help}}></p>
                </>
            )}

        </div>
    );
};

export default VerifyEmail;